import axios from 'axios'

export const indexExitAssessments = () => axios.get('advisor/exit-assessment').then(({ data }) => data)

export const storeExitAssessment = data => axios.post('advisor/exit-assessment', data).then(({ data }) => data)

export const resendExitAssessment = id => axios.post(`advisor/exit-assessment/${id}/resend`).then(({ data }) => data)
